<template>
  <div class="">
    <span v-if="days"> {{days}}{{$t('common.dayContent')}} </span>{{ hours }}:{{ minutes }}:{{ seconds }}
  </div>
</template>

<script>
export default {
  props: {
    targetTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timer: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },
  mounted() {
    this.calculateCountdown();
    this.timer = setInterval(this.calculateCountdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    calculateCountdown() {
      const targetDate = new Date(this.targetTime).getTime();
      const currentDate = new Date().getTime();
      const remainingTime = targetDate - currentDate;

      if (remainingTime <= 0) {
        clearInterval(this.timer);
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        return;
      }

      this.days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    }
  }
};
</script>

<style scoped>
.countdown {
 font-size: 1rem !important;
  font-weight: bold;
  margin-left: 10px;
  /* color: #333; */
}
</style>
